var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"单图","width":"660px"},on:{"ok":_vm.handleOk},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('TextbookMakerUpload',{attrs:{"defaultUrl":_vm.img.src,"path":`textbook/${_vm.textbook.id}/${_vm.unit.folderName}/images/`},on:{"changeImgUrl":(url) => _vm.changeImgUrl(url)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }